// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Landing-___landing__container___33z_2","page-content":"src-components-Landing-___landing__page-content___3uWT_","image":"src-components-Landing-___landing__image___2RzeM","logo-box":"src-components-Landing-___landing__logo-box___2Zzjt","social-link":"src-components-Landing-___landing__social-link___2Vmx2","social-icon":"src-components-Landing-___landing__social-icon___1jcyT","news-section":"src-components-Landing-___landing__news-section___3Ve2q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Landing/landing.css
// module id = 779
// module chunks = 0